import { CDN_IMAGES_URL, BULLET_UNICODE_CHAR } from 'consts/global';

export const CARD_TOKENIZATION_FORM_NAME = 'cardTokenizationForm';

export const SCAN_CREDIT_CARD_FIELD_NAMES = {
  number: 'cardNumber',
  expiration: 'expdate',
  cardholder: 'cardholder'
};

export const MANDATORY_CARD_FIELDS = {
  number: SCAN_CREDIT_CARD_FIELD_NAMES.number,
  cardholder: SCAN_CREDIT_CARD_FIELD_NAMES.cardholder,
  expiration: SCAN_CREDIT_CARD_FIELD_NAMES.expiration,
  cvv: 'cvv'
};

export const EXCLUDE_CARD_FIELDS = [
  'number',
  'expiration_month',
  'expiration_year',
  'name',
  'expiration',
  'cvv'
];

export const ADDRESS_FIELDS_TYPE = {
  main_address: 'mainAddress',
  billing_address: 'billingAddress'
};

export const ADDRESS_FIELDS = {
  country: 'country',
  city: 'city',
  line_1: 'line_1',
  state: 'state',
  zip: 'zip'
};

export const CARD_AUTOCOMPLETES = {
  number: 'cc-number',
  name: 'cc-name',
  cvv: 'cc-csc',
  expiration: 'cc-exp'
};

export const CARD_ERRORS = {
  number: 'invalid_card_number',
  number_incomplete: 'incomplete_card_number',
  cvv: 'invalid_card_cvv',
  expiration: 'invalid_card_expiration',
  amex_not_supported: 'amex_card_not_supported'
};

// TODO - redundant when finish redesign
export const CARD_FORMATS = {
  card_number: '#### #### #### #### ###',
  expiration_month: '##',
  expiration_year: '##',
  cvv: '####'
};

export const COUNTRIES_TO_SHOW_BILLING = ['US', 'CA', 'GB'];

export const BILLING_ADDRESS_COLLECT_TYPES = {
  AUTO: 'auto',
  ALWAYS: 'always'
};

export const BILLING_ADDRESS_COLLECT_VALUES = {
  [BILLING_ADDRESS_COLLECT_TYPES.AUTO]: false,
  [BILLING_ADDRESS_COLLECT_TYPES.ALWAYS]: true
};

export const CARD_FORM_VIEW = {
  LIST: 'LIST',
  ADD: 'ADD',
  EDIT: 'EDIT',
  SUBSCRIPTION_ADD: 'SUBSCRIPTION_ADD'
};

export const CARD_BRANDS = {
  visa: {
    type: 'visa',
    logo: `${CDN_IMAGES_URL}/visa-v1.2.3.svg`,
    patterns: [4],
    name: 'Visa',
    skip_luhn: false
  },
  mastercard: {
    type: 'mastercard',
    logo: `${CDN_IMAGES_URL}/mastercard-v1.2.3.svg`,
    patterns: [
      2221, 2222, 2223, 2224, 2225, 2226, 2227, 2228, 2229, 223, 224, 225, 226, 227, 228,
      229, 23, 24, 25, 26, 271, 2720, 51, 52, 53, 54, 55
    ],
    name: 'MasterCard',
    skip_luhn: false
  },
  amex: {
    type: 'amex',
    logo: `${CDN_IMAGES_URL}/amex-v1.2.3.svg`,
    patterns: [34, 37],
    name: 'American Express',
    skip_luhn: false
  },
  'diners club': {
    type: 'diners club',
    logo: `${CDN_IMAGES_URL}/diners.svg`,
    patterns: [300, 301, 302, 303, 304, 305, 36, 38],
    name: 'Diners Club',
    skip_luhn: false
  },
  jcb: {
    type: 'jcb',
    logo: `${CDN_IMAGES_URL}/jcb.svg`,
    patterns: [3528, 3529, 353, 354, 355, 356, 357, 358, 1800, 2131, 357266],
    name: 'JCB',
    skip_luhn: false
  },
  maestro: {
    type: 'maestro',
    logo: `${CDN_IMAGES_URL}/maestro.svg`,
    patterns: [
      500, 5010, 5011, 5012, 5013, 5014, 5015, 5016, 5017, 5018, 502, 503, 504, 505, 506,
      507, 508, 509, 56, 57, 58, 59, 6010, 6012, 6013, 6014, 6015, 6016, 6017, 6018, 6019,
      602, 603, 604, 605, 6060, 616788, 62183, 62186, 62188, 62198, 62199, 6220, 622110,
      627089, 62709601, 6271, 6272, 6273, 6274, 6275, 6276, 6277, 6278, 6279, 6280, 6281,
      6294, 6301, 630490, 633857, 63609, 6361, 636392, 636708, 637043, 637102, 637118,
      637187, 637529, 639, 640, 641, 642, 643, 670, 671, 672, 673, 674, 675, 677, 6760,
      6761, 6762, 6763, 6764, 6765, 6766, 6768, 6769, 6771, 679
    ],
    name: 'Maestro',
    skip_luhn: false
  },
  'china unionpay': {
    type: 'china unionpay',
    logo: `${CDN_IMAGES_URL}/cup.svg`,
    patterns: [
      620, 6210, 6212, 6213, 6214, 6215, 6216, 6217, 621977, 622126, 622127, 622128,
      622129, 62213, 62214, 62215, 62216, 62217, 62218, 62220, 62221, 62222, 62223, 62224,
      62225, 62226, 62227, 62228, 62229, 6223, 6224, 6225, 6226, 6227, 6228, 6229, 623,
      624, 625, 626, 62702, 62704, 62706, 62707, 6282, 6283, 6284, 6291, 6292, 632062,
      685800, 69075
    ],
    name: 'China UnionPay',
    skip_luhn: true
  },
  rupay: {
    type: 'rupay',
    logo: `${CDN_IMAGES_URL}/rupay.svg`,
    patterns: [6061, 6062, 6063, 6064, 6065, 6066, 6067, 6068, 6069, 607, 608],
    name: 'RuPay',
    skip_luhn: true
  },
  discover: {
    type: 'discover',
    logo: `${CDN_IMAGES_URL}/discover.svg`,
    patterns: [
      300, 301, 302, 303, 304, 305, 38, 39, 60110, 60112, 60113, 601140, 601141, 601142,
      601143, 601144, 601174, 601177, 601178, 601179, 601186, 601187, 601188, 601189,
      60119, 644, 645, 646, 647, 648, 649, 65
    ],
    name: 'Discover',
    skip_luhn: false
  }
};

export const FALL_BACK_CARD_LOGO = `${CDN_IMAGES_URL}/fallback-credit-card.svg`;

export const THREE_DIGITS_MASK = `${BULLET_UNICODE_CHAR}${BULLET_UNICODE_CHAR}${BULLET_UNICODE_CHAR}`;

export const FOUR_DIGITS_MASK = `${THREE_DIGITS_MASK}${BULLET_UNICODE_CHAR}`;

export const NUMBER_MASK = `
  ${FOUR_DIGITS_MASK}
  ${FOUR_DIGITS_MASK}
  ${FOUR_DIGITS_MASK}
`;

export const FOUR_DIGITS_CVV_CARDS_MASKS = {
  [CARD_BRANDS.amex.type]: FOUR_DIGITS_MASK
};

export const SAVE_FOR_FUTURE = 'saveForFuture';
export const SET_AS_DEFAULT = 'setAsDefault';
export const HIDE_SAVE_CARD_CHECKBOX = 'hideSaveCardCheckBox';

export const BIN_LENGTH = 6;
export const EXPANDED_BIN_LENGTH = 12;
